const EMAIL = /^[A-Z0-9._%+\-]+@[A-Z0-9.\-]+\.[A-Z]{2,}$/i;

export function referrerNameError(value: string): string | null {
    return textError(value, 'il nome', 100);
}

export function referrerSurnameError(value: string): string | null {
    return textError(value, 'il cognome', 100);
}

export function referrerEmailError(value: string): string | null {
    const raw = (value || '').trim();
    if (!raw) {
        return 'Inserisci un indirizzo email.';
    }
    if (raw.length > 200 || !EMAIL.test(raw)) {
        return 'Inserisci un indirizzo email valido.';
    }
    return null;
}

function textError(value: string, label: string, maxLength: number): string | null {
    const raw = (value || '').trim();
    if (!raw) {
        return 'Inserisci ' + label + '.';
    }
    if (raw.length > maxLength) {
        return label.charAt(0).toUpperCase() + label.slice(1) + ' può contenere al massimo ' + maxLength + ' caratteri.';
    }
    return null;
}
